export const LensLabel = {
  RETURN_POLICY_HEADER: 'Lens return policy',
  RETURN_POLICY_DESC:
    '  Our 30-day returns policy means WALDO manages all returns and processing in-house! No fees to the office, no shipping.',
  RETURN_CTA: 'Learn more',
};
